import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8442e3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "category-item" }
const _hoisted_2 = ["onClick"]

import {computed, ref} from 'vue'
    import type { Ref } from 'vue';

    interface IProps {
        categories: Array<any>
        treeStyle: number
    }
    
export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryItem',
  props: {
    categories: {},
    treeStyle: {}
  },
  emits: ['selected'],
  setup(__props: any, { emit }) {

const props = __props;

    

    let style = computed(() => {
        let str = ''
        for(let i = 0; i < props.treeStyle; i++){
            str+= '-'
        }
        return str
    })

    

    function onSelected(id :number){
        emit('selected', id)
    }

return (_ctx: any,_cache: any) => {
  const _component_CategoryItem = _resolveComponent("CategoryItem", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        _createElementVNode("p", {
          style: 'width: 100%;',
          onClick: ($event: any) => (_ctx.$emit('selected', category.id))
        }, [
          _createElementVNode("span", null, _toDisplayString(`${_unref(style)} ${category.name}`), 1)
        ], 8, _hoisted_2),
        (category.children.length > 0)
          ? (_openBlock(), _createBlock(_component_CategoryItem, {
              key: 0,
              categories: category.children,
              treeStyle: _ctx.treeStyle + 1,
              onSelected: onSelected
            }, null, 8, ["categories", "treeStyle"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})